export const canUserEditAreasOfInterest = (id: number, currentUserId: number) => {
  return id === currentUserId;
};
